var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { QuerySpaceAdminRepository } from './space-admin-repository.interface';
import { SpaceAdminModel } from '../model/space-admin';
let SpaceAdminServiceImpl = class SpaceAdminServiceImpl {
    constructor(_querySpaceAdminRepository, _spaceAdminModel) {
        this._querySpaceAdminRepository = _querySpaceAdminRepository;
        this._spaceAdminModel = _spaceAdminModel;
    }
    async querySpaceAdmins(spaceId) {
        this._clearSpaceAdmins();
        const result = await this._querySpaceAdminRepository.querySpaceAdmins(spaceId);
        this._fillSpaceAdmins(result);
        return result;
    }
    _clearSpaceAdmins() {
        this._spaceAdminModel.update((modelData) => {
            modelData.admins = [];
            modelData.loading = true;
            return modelData;
        });
    }
    _fillSpaceAdmins(admins) {
        this._spaceAdminModel.update((modelData) => {
            modelData.admins = admins;
            modelData.loading = false;
            return modelData;
        });
    }
};
SpaceAdminServiceImpl = __decorate([
    injectable(),
    __param(0, inject(QuerySpaceAdminRepository)),
    __param(1, inject(SpaceAdminModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof QuerySpaceAdminRepository !== "undefined" && QuerySpaceAdminRepository) === "function" ? _a : Object, typeof (_b = typeof SpaceAdminModel !== "undefined" && SpaceAdminModel) === "function" ? _b : Object])
], SpaceAdminServiceImpl);
export { SpaceAdminServiceImpl };
